<div class="wrapper" [class.active]="isActive">
  <span>{{initials | uppercase}}</span>
</div>
